import React from 'react';
import PropTypes from 'prop-types';
import { ContentCard } from '@/pages/inside/tenant/style';

const SprintProgressCard = ({ sprintName, totalTasks, completedTasks, inProgressTasks, pendingTasks, title }) => {
    const tTasks = typeof totalTasks === 'number' ? totalTasks : 0;
    const cTasks = typeof completedTasks === 'number' ? completedTasks : 0;
    const ipTasks = typeof inProgressTasks === 'number' ? inProgressTasks : 0;
    const pTasks = typeof pendingTasks === 'number' ? pendingTasks : 0;

    const total = tTasks || 1;
    const completedPct = (cTasks / total) * 100;
    const inProgressPct = (ipTasks / total) * 100;
    const pendingPct = (pTasks / total) * 100;

    return (
        <ContentCard $padding="24px" $marginBottom="20px">
            <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--ant-color-text, #111827)', margin: '0 0 20px 0', fontFamily: 'var(--font-family-geist)' }}>
                {title || `Current Sprint: ${sprintName || 'Sprint 12'}`}
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--ant-color-text-secondary, #6b7280)', marginBottom: 8, letterSpacing: '0.05em' }}>
                        TOTAL TASKS
                    </span>
                    <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--ant-color-text, #111827)' }}>
                        {totalTasks}
                    </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--ant-color-text-secondary, #6b7280)', marginBottom: 8, letterSpacing: '0.05em' }}>
                        COMPLETED
                    </span>
                    <div style={{ fontSize: 24, fontWeight: 700, color: '#10b981', marginBottom: 12 }}>
                        {completedTasks}
                    </div>
                    <div style={{ width: '100%', height: 6, background: '#e5e7eb', borderRadius: 3, overflow: 'hidden' }}>
                        <div style={{ height: '100%', background: '#10b981', width: `${completedPct}%`, borderRadius: 3 }} />
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--ant-color-text-secondary, #6b7280)', marginBottom: 8, letterSpacing: '0.05em' }}>
                        IN PROGRESS
                    </span>
                    <div style={{ fontSize: 24, fontWeight: 700, color: '#8b5cf6', marginBottom: 12 }}>
                        {inProgressTasks}
                    </div>
                    <div style={{ width: '100%', height: 6, background: '#e5e7eb', borderRadius: 3, overflow: 'hidden' }}>
                        <div style={{ height: '100%', background: '#8b5cf6', width: `${inProgressPct}%`, borderRadius: 3 }} />
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--ant-color-text-secondary, #6b7280)', marginBottom: 8, letterSpacing: '0.05em' }}>
                        PENDING
                    </span>
                    <div style={{ fontSize: 24, fontWeight: 700, color: '#6b7280', marginBottom: 12 }}>
                        {pendingTasks}
                    </div>
                    <div style={{ width: '100%', height: 6, background: '#e5e7eb', borderRadius: 3, overflow: 'hidden' }}>
                        <div style={{ height: '100%', background: '#6b7280', width: `${pendingPct}%`, borderRadius: 3 }} />
                    </div>
                </div>
            </div>
        </ContentCard>
    );
};

SprintProgressCard.propTypes = {
    sprintName: PropTypes.string,
    totalTasks: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    completedTasks: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inProgressTasks: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pendingTasks: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
};

export default SprintProgressCard;
